import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TargetGroupFilter, { targetGroupOptions, matchesTargetGroup } from './TargetGroupFilter'
import styles from './style.module.scss'

/*
 * Liste der Dokumentvorlagen (PDF/Urkunden). Reine Ansicht — ein Klick öffnet
 * die Detailansicht mit Beispieldatensätzen und Live-PDF.
 */
export default function DocumentList({ items, onOpen }) {
	const { t } = useTranslation()
	const [targetGroup, setTargetGroup] = useState('')

	const groupOptions = useMemo(() => targetGroupOptions(items), [items])
	const filtered = useMemo(
		() => items.filter(item => matchesTargetGroup(item, targetGroup)),
		[items, targetGroup]
	)

	return (
		<div className={styles.listWrap}>
			<div className={styles.listToolbar}>
				<p className={styles.counter}>
					{filtered.length} {t('Templates')}
				</p>
			</div>

			<TargetGroupFilter options={groupOptions} value={targetGroup} onChange={setTargetGroup} />

			<div className={styles.cards}>
				{filtered.map(item => (
					<button type="button" key={item.key} className={styles.card} onClick={() => onOpen(item.key)}>
						<div className={styles.cardHead}>
							<span className={styles.cardTitle}>{item.title}</span>
							{item.isStatic && <span className={styles.badgeInactive}>{t('Static')}</span>}
						</div>

						<p className={styles.cardTrigger}>{item.trigger}</p>

						<div className={styles.cardMeta}>
							<span className={styles.targetGroups}>
								{item.targetGroups.map(g => (
									<span key={g} className={styles.targetGroup}>
										{g}
									</span>
								))}
							</span>
							{item.companyTypes?.length > 0 && (
								<span className={styles.cardPlaceholders}>{item.companyTypes.join(' · ')}</span>
							)}
						</div>
					</button>
				))}
			</div>
		</div>
	)
}

DocumentList.propTypes = {
	items: PropTypes.array.isRequired,
	onOpen: PropTypes.func.isRequired
}
